/**
 * Chart color palette derived from Chartwit design kit.
 * These hex values are used directly by Recharts.
 * The CSS variable versions (--chart-*) are available for Tailwind usage.
 */

export const CHART_COLORS = {
  blue: '#0074F4',
  purple: '#8B47FB',
  purpleLight: '#B88AFD',
  magenta: '#D447FB',
  coral: '#FF677B',
  cyan: '#7CDBE7',
  navy: '#0C1430',
  /* Legacy aliases — map old names to new palette */
  teal: '#7CDBE7',
  red: '#FF677B',
  sky: '#7CDBE7',
  orange: '#D447FB',
  pink: '#D447FB',
} as const

/**
 * Ordered palette for multi-series charts.
 * Designed for maximum contrast between adjacent colors.
 */
export const CHART_PALETTE = [
  CHART_COLORS.blue,
  CHART_COLORS.purple,
  CHART_COLORS.magenta,
  CHART_COLORS.coral,
]

/**
 * Gradient definitions for area charts (mimics the design kit's
 * soft gradient fills under line charts).
 */
export const CHART_GRADIENTS = {
  blue: { start: '#0074F4', end: '#0074F400' },
  purple: { start: '#8B47FB', end: '#8B47FB00' },
  magenta: { start: '#D447FB', end: '#D447FB00' },
  coral: { start: '#FF677B', end: '#FF677B00' },
  cyan: { start: '#7CDBE7', end: '#7CDBE700' },
  /* Legacy aliases */
  teal: { start: '#7CDBE7', end: '#7CDBE700' },
  sky: { start: '#7CDBE7', end: '#7CDBE700' },
}

/**
 * Shared Recharts style config for consistent look
 */
export const CHART_STYLE = {
  fontSize: 12,
  fontFamily: 'Inter, system-ui, sans-serif',
  axisColor: '#94A3B8',
  gridColor: '#E2E8F0',
  gridColorDark: '#1E293B',
  tooltipBg: '#FFFFFF',
  tooltipBorder: '#E2E8F0',
  tooltipBgDark: '#0F172A',
  tooltipBorderDark: '#1E293B',
}
